<template>
    <div class="side-bar">
        
        <!-- pc端 -->
        <div class="cargory">
            <div class="cargory-item" v-for="(item,index) in types" :class="{cargoryItemAcitve:oneID == item.id || showSubOneID == item.id ,opaticy: oneID != null && oneID != item.id ||  showSubOneID != null && showSubOneID != item.id}" :key="index">
                <!-- <el-popover
                    placement="bottom"
                    width="407"
                    height="370"
                    popper-class="cat-popper"
                    @hide="popoverHide"
                    @show="popoverHide"
                    :visible-arrow="true"
                    trigger="click"> -->
                    <div :class="`oneCat oneCat_${index}`" slot="reference" @click="() => {
                        catSelect(item.id, item, item)
                        openSub(item.id)
                    }">
                        <!-- <img :class="`bj_${index}`" class="bj" :src="require(`@/assets/img/cat_bj_${index}.png`)" alt="" srcset=""> -->
                        <img :class="`icon_${index}`" class="icon" :src="require(`@/assets/img/cat-icon_${index}.png`)" alt="" srcset="">
                        <span>{{ item.typeName }}</span>
                    </div>
                    <div class="subTypes" :class="{showSubTypes: showSubOneID == item.id && showSubTypes}">
                        <div class="cat-two" v-for="(ite,i) in item.subTypes" :key="i">
                            <div class="title">
                                <div class="tiao"></div>
                                <span>{{ ite.secTypeName }}：</span>
                            </div>
                            <div class="tags">
                                <span class="type-tag" v-for="(ite_three,threeIndex) in ite.thirdTypes"  :class="{active:isArrayId(ite_three.id, typeId)}" :key="threeIndex" @click="catSelect(ite_three.id, ite_three, item, ite.id, ite.pid)">{{ ite_three.thirdTypeName || '无' }}</span>
                            </div>
                        </div>
                        <div class="clickCloseCat" @click="closeSub(item.id)">
                            <div class="el-icon-arrow-up"></div>
                        </div>
                    </div>
                <!-- </el-popover> -->
                
                
                <!-- <div class="oneCat" @click="catSelect(item.id, item, item)">
                    <img :class="`icon_${index}`" class="icon" :src="require(`@/assets/img/catgory-img_${index}.png`)" alt="" srcset="">
                    {{ item.typeName }}
                </div>-->
                
            </div>
        </div>

        <!-- 移动端 -->
        <div class="cargory-mobile">
            <div class="cargory-mobile-top">
                <div class="cargory-item-mobile" v-for="(item,index) in types" :class="{cargoryItemAcitve:oneID == item.id }" :key="index" @click="catSelect(item.id, item, item)">
                    <div class="onCat">
                        <span>{{ item.typeName }}</span>
                        <div class="tiao"></div>
                    </div>
                </div>
            </div>
            <div class="subTypes">
                <div class="cat-two" v-for="(ite,i) in mobileCat" :key="i">
                    <div class="title">
                        <span>{{ ite.secTypeName }}：</span>
                    </div>
                    <div class="tags">
                        <span class="type-tag" v-for="(ite_three,threeIndex) in ite.thirdTypes"  :class="{active:isArrayId(ite_three.id, typeId)}" :key="threeIndex" @click="catSelect(ite_three.id, ite_three, oneItem, ite.id, ite.pid)">{{ ite_three.thirdTypeName || '无' }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getTypes } from '@/api/api';
let array = [];
let pidArray = [];
export default {
    name: "SideBar",
    props: {
      types: {
        type: Array,
        default: () => []
      },
      typeid: {
        type: String,
        default: ''
      },
    },
    data(){
        return {
            typeId: sessionStorage.getItem('typeId') ? sessionStorage.getItem('typeId').split(',') : [],
            typeArray:[],
            mobileCat:[],
            oneItem:{},
            arrow: true,
            showSubOneID: null,
            oneID: sessionStorage.getItem('oneID') && sessionStorage.getItem('oneID') != 'null' ? sessionStorage.getItem('oneID') : null, // 第一层id 用于控制样式
            isOpt: sessionStorage.getItem('isOpt') && sessionStorage.getItem('isOpt') != 'false' ? sessionStorage.getItem('isOpt') : false // 用控制
        };
    },

    mounted() {
        this.$root.eventHub.$on("resetForm", this.reset);
        console.log(typeof sessionStorage.getItem('oneID'),typeof sessionStorage.getItem('isOpt'))
        // 去调取methods方法获取手机端展示分类数据
        if(document.documentElement.clientWidth < 800){
            if(this.oneID){
                this.getTypes()
            }
        }
    },
    
    beforeDestroy () {
        this.$root.eventHub.$off('resetForm')
    },
    
    watch: {
        'typeId':function(val, oldVal){//普通的watch监听
            if(!val || val == ''){
                this.removeOpt()
            }
        },
    },

    methods: {  
        // 拿取后台手机端分类数据处理渲染
        getTypes() {
            getTypes({
                id: this.oneID
            }).then(({ data }) => {
                if(data.code == 200 || data.code == 0){
                    console.log(data)
                    this.mobileCat = data.t;
                }
            })
        },

        // 点击下拉箭头打开选项框
        openSub(oneId) {
            this.showSubOneID = oneId;
            this.showSubTypes = true;
        },

        closeSub(oneId) {
            this.showSubOneID = null;
            this.showSubTypes = false;
        },


        popoverHide() {
            this.arrow = false
        },

        removeOpt(){
            this.isOpt = false;
            sessionStorage.setItem('isOpt',false)
        },

        // 选择的分类 params ==》 选择分类ID 调用this $emit（）
        catSelect(params, item, PItem, twoId, twoPid) {
            if(PItem.id != this.oneID){
                array = [];
            }
            this.oneID = PItem.id;
            sessionStorage.setItem('oneID', PItem.id)
            this.isOpt = true;
            sessionStorage.setItem('isOpt', true)
            this.$root.eventHub.$emit("clearSeartch");
            let typeID = []; //存储选择得分类
            let typeName = [];
            // 判断是否选择点击的是三级分类，如果是就进去下一层判断 不是直接赋值
            if(item.pid){
                if(array.length > 0){
                    if(JSON.stringify(array).indexOf(twoId)!= -1){
                        array.map((value, index) => {
                            if(twoId == value.pid){
                                if(JSON.stringify(array).indexOf(params)!= -1){
                                    array.map((v, index) => {
                                        if(params == v.id){
                                            array.splice(index, 1)
                                        }
                                    })
                                } else {
                                    array.splice(index, 1, item)
                                }
                            }
                        })
                    } else {
                        array.push(item)
                    }
                    
                } else {
                    array.push(item)
                }
                // 将处理好的数据直接覆盖选择的分类列表
                this.typeArray = array;
            } else {
                if(document.documentElement.clientWidth < 800){
                    console.log(item)
                    this.oneItem = item
                    this.getTypes();
                }
                this.typeArray = [{
                    ...item 
                }];
            }
            this.typeArray.map((i, n) => {
                typeID.push(i.id);
                typeName.push(i.thirdTypeName || i.typeName)
            });
            sessionStorage.setItem('catgName', typeName.toString())
            this.typeId = typeID;
            this.$emit('selectCat', typeID.toString())
        },
        

        // 重置选择id
        reset() {
            this.typeId = [];
            array = [];
            this.oneID = null;
            this.mobileCat = {};
            sessionStorage.setItem('oneID', null)
            sessionStorage.setItem('typeId', [])
        }
    },
}
</script>
<style scoped>
    .side-bar {
        width:100%;
    }

    
    .cat-popper {
        height: 440px!important;
        border-radius: 0px 0px 30px 30px!important;
        opacity: 0.94!important;
    }   

    .opaticy {
        opacity: 0.4!important;
        background: #4E4E4E!important;
    }
    
    .cargory-item {
        opacity: 1;
    }

    .cargoryItemAcitve {
        opacity: 1!important;
    }

    .noOpaticy {
        opacity: 1!important;
    }
    .oneCat {
        width: 100%;
        height:160px;
        text-align: center;
        font-size: 36px;
        background: url('../assets/img/cat_bj_1.png') no-repeat;
        cursor: pointer;
        font-family: STSongti-SC-Bold, STSongti-SC;
        color: #111111;
        background-size: 100% 100%!important;
        position: relative;
    }
    .oneCat_0 {
        background: url('../assets/img/cat_bj_0.png') no-repeat;
    }
    .oneCat_1 {
        background: url('../assets/img/cat_bj_1.png') no-repeat;
    }
    .oneCat_2 {
        background: url('../assets/img/cat_bj_2.png') no-repeat;
    }
    .oneCat_3 {
        background: url('../assets/img/cat_bj_3.png') no-repeat;
    }
    .oneCat_4 {
        background: url('../assets/img/cat_bj_4.png') no-repeat;
    }
    .oneCat_5 {
        background: url('../assets/img/cat_bj_5.png') no-repeat;
    }
    .oneCat_6 {
        background: url('../assets/img/cat_bj_6.png') no-repeat;
    }
    .oneCat_7 {
        background: url('../assets/img/cat_bj_7.png') no-repeat;
    }
    .oneCat span {
        color:#fff;
        font-family:宋体;
        font-weight: bold;
        font-size:48px;
        display: inline-block;
        padding-top: 54px;
    }
    .oneCat .icon {
        width:60%;
        height: auto;
        top:33px;
        left:0;
        right:0;
        margin: auto;
        position: absolute;
    }
    .oneCat_0 .icon{
        width: 154px;
        height:55px;
        top:23px;
    }
    .oneCat_4 .icon{
        width: 246px;
        height:55px;
        top:23px;
    }
    .oneCat_5 .icon{
        width: 262px;
        height:55px;
        top:23px;
    }
    .oneCat_6 .icon{
        width: 148px;
        height:55px;
        top:23px;
    }
    .oneCat_7 .icon{
        width: 130px;
        height:55px;
        top:23px;
    }
    @media (min-width: 801px) {
        .subTypes {
            height: 0;
            background: #FFFFFF;
            display: none;
            transition: 1s;
            position: relative;
            border-radius: 0px 0px 30px 30px;
            
        }

        .showSubTypes {
            height: auto;
            padding: 30px;
            display: block;
        }
    }
    
    .subTypes .cat-two{
        margin-top:14px;
        display: inline;
    }
    .cat-two .title {
        display: flex;
        align-items: center;
    }
    .cat-two .title span{
        color: #666; 
        font-size:20px;
        font-weight: 900;
        font-family: 宋体;
    }
    .cat-two .tiao{
        width: 4px;
        margin-right:8px;
        height: 20px;
        background: #D1AA72;
        border-radius: 2px;
        opacity: 0.8;
    }
    .cat-two .tags{
        padding-left:12px;
    }
    .cat-two .type-tag {
        margin-right: 6px;       
        font-size:18px;
        font-family: 宋体;
        display:inline-block;
        padding: 2px 3px;
        cursor: pointer;
        overflow-wrap:break-word;
        margin-bottom:6px;
        color:#666;
    }
    .active {
        background: #182675;
        border-radius: 4px;
        color:#fff!important;
        padding: 1px 3px;
    }

    .clickShowCat {
        width: 28px;
        height: 16px;
        background: #D1AA72;
        position: absolute;
        bottom:12px;
        right:12px;
        border-radius: 8px;
    }
    .clickShowCat div {
        font-size:10px;
        padding:0;
        position: absolute;
        left:0;
        right:0;
        top:2px;
        bottom:0;
        margin: auto;
        margin:0;
        color:#fff;
    }

    .clickCloseCat{
        width: 28px;
        height: 16px;
        background: #D1AA72;
        position: absolute;
        bottom:15px;
        cursor: pointer;
        left:0;
        right:0;
        margin:  auto;
        border-radius: 8px;
    }
    .clickCloseCat div {
        font-size:10px;
        padding:0;
        position: absolute;
        left:0;
        right:0;
        top:2px;
        text-align: center;
        bottom:0;
        margin: auto;
        margin:0;
        color:#fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/SideBar.vue